import { Action } from 'redux';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import { IUser } from '../types/user';

export const USERS_FETCH_REQUEST = 'USERS_FETCH_REQUEST';
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';
export const USERS_ERROR = 'USERS_ERROR';
export const USER_DETAIL_FETCH_REQUEST = 'USER_DETAIL_FETCH_REQUEST';
export const USER_DETAIL_FETCH_SUCCESS = 'USER_DETAIL_FETCH_SUCCESS';
export const USER_REMOVE_REQUEST = 'USER_REMOVE_REQUEST';
export const USER_REMOVE_SUCCESS = 'USER_REMOVE_SUCCESS';
export const USER_BLOCK_REQUEST = 'USER_BLOCK_REQUEST';
export const USER_BLOCK_SUCCESS = 'USER_BLOCK_SUCCESS';

export interface IUsersFetchRequestAction extends Action {
  type: typeof USERS_FETCH_REQUEST;
  payload: {
    roles: Array<'candidate' | 'employer'>;
    search?: string;
  } & IPaginationParams;
}

export interface IUsersFetchSuccessAction extends Action {
  type: typeof USERS_FETCH_SUCCESS;
  payload: { users: IUser[]; meta: IPaginationMetaResponse };
}

export interface IUsersErrorAction extends Action {
  type: typeof USERS_ERROR;
  message: string;
}

export interface IUserDetailFetchRequestAction extends Action {
  type: typeof USER_DETAIL_FETCH_REQUEST;
  payload: { id: number };
}

export interface IUserDetailFetchSuccessAction extends Action {
  type: typeof USER_DETAIL_FETCH_SUCCESS;
  payload: { user: IUser };
}

export interface IUserRemoveRequestAction extends Action {
  type: typeof USER_REMOVE_REQUEST;
  payload: {
    id: number;
  };
}

export interface IUserRemoveSuccessAction extends Action {
  type: typeof USER_REMOVE_SUCCESS;
  payload: {
    user: IUser;
  };
}

export interface IUserBlockRequestAction extends Action {
  type: typeof USER_BLOCK_REQUEST;
  payload: {
    id: number;
    block: boolean;
  };
}

export interface IUserBlockSuccessAction extends Action {
  type: typeof USER_BLOCK_SUCCESS;
  payload: {
    id: number;
  };
}

export type IUsersFetchAction =
  | IUsersFetchSuccessAction
  | IUsersErrorAction
  | IUserDetailFetchSuccessAction
  | IUserRemoveSuccessAction
  | IUserBlockSuccessAction;

export function fetchUsersRequest(
  roles?: Array<'candidate' | 'employer'>,
  params?: { search?: string } & IPaginationParams
): IUsersFetchRequestAction {
  return {
    type: USERS_FETCH_REQUEST,
    payload: {
      roles: roles || ['candidate', 'employer'],
      ...params,
    },
  };
}

export function fetchUsersSuccess(
  users: IUser[],
  meta: IPaginationMetaResponse
): IUsersFetchSuccessAction {
  return {
    type: USERS_FETCH_SUCCESS,
    payload: {
      users,
      meta,
    },
  };
}

export function usersError(message: string): IUsersErrorAction {
  return {
    type: USERS_ERROR,
    message,
  };
}

export function fetchUserDetailRequest(id: number): IUserDetailFetchRequestAction {
  return {
    type: USER_DETAIL_FETCH_REQUEST,
    payload: { id: id },
  };
}

export function fetchUserDetailSuccess(user: IUser): IUserDetailFetchSuccessAction {
  return {
    type: USER_DETAIL_FETCH_SUCCESS,
    payload: {
      user,
    },
  };
}

export function removeUserRequest(userId: number): IUserRemoveRequestAction {
  return {
    type: USER_REMOVE_REQUEST,
    payload: {
      id: userId,
    },
  };
}

export function removeUserSuccess(user: IUser): IUserRemoveSuccessAction {
  return {
    type: USER_REMOVE_SUCCESS,
    payload: {
      user: user,
    },
  };
}

export function blockUserRequest(userId: number, block: boolean): IUserBlockRequestAction {
  return {
    type: USER_BLOCK_REQUEST,
    payload: {
      id: userId,
      block: block,
    },
  };
}

export function blockUserSuccess(userId: number): IUserBlockSuccessAction {
  return {
    type: USER_BLOCK_SUCCESS,
    payload: {
      id: userId,
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/users.ts